






























































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import chatBox from '@/components/ChatBox.vue';

@Component({
  components: {
    chatBox,
  },
})
export default class Messenger extends Vue {
  // visible= false;
  dialog = false;

  badges= [] as any;

  doc = '';

  searchKey = '';

  searchResult = [] as any;

  mounted() {
    this.$store.dispatch('bindChatRoom');
  }

  onClose() {
    this.dialog = false;
  }

  open(doc: any) {
    this.doc = doc;
    // this.visible = true;
    this.dialog = true;
    // const index = this.badges.indexOf((badge: any) => (badge.id === doc.id));
    // this.badges.splice(index, 1);
  }

  doSearch(searchKey: any) {
    if (searchKey) {
      const filtered = this.chatRooms
        .filter((room: any) => (room.participants.find((user: any)=> user
        .name.toUpperCase().match(searchKey.toUpperCase()))));
      this.searchResult = filtered;
    } else {
      this.searchResult = [];
    }
  }

  get chatRooms() {
    return this.$store.state.chatRooms.filter((doc: any) => (
      doc.participants.find((Obj: any) => (Obj.id === this.currentUser.uid))));
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  user(item: any) {
    if (item.participants) {
      return item.participants.find((user: any) => (user.id !== this.currentUser.uid));
    }
    return '';
  }

  // eslint-disable-next-line
  get changes() {
    if (this.chatRooms.length) {
      return this.chatRooms;
    }
    return undefined;
  }

  msgLength(msgs: any) {
    const frndmsgs = msgs.filter((massag: any) => (massag.participantId !== this.currentUser.uid));
    return frndmsgs.length;
  }

  @Watch('chatRooms')
  onPropertyChanged = (value: any, oldValue: any) => {
    // if (value.length) {
    // }
    // this.componentKey += 1;
  }
}
